import { render, staticRenderFns } from "./GaaUsers.vue?vue&type=template&id=48f5a04d&scoped=true&"
import script from "./GaaUsers.vue?vue&type=script&lang=js&"
export * from "./GaaUsers.vue?vue&type=script&lang=js&"
import style0 from "./GaaUsers.vue?vue&type=style&index=0&id=48f5a04d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f5a04d",
  null
  
)

export default component.exports